class AnalyticsController {
  constructor(AnalyticsService, $q) {
    "ngInject"

    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  $onInit() {    
    this.isLoading = false;  
  }
}

export default AnalyticsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-traffic/analytics-traffic.controller.js
 **/